import React, { CSSProperties } from 'react';
import cn from 'classnames';
import { CirclePenIcon } from '@components/Icons';
import styles from './WorkspaceAvatar.module.scss';
import {
  acceptedAvatarImageTypes,
  useWorkspaceContext,
} from '@support/hooks/use-workspace-context';
import BoringAvatar from 'boring-avatars';

// TODO: this should be a separate component used for both user and workspace avatars
export const FallbackWorkspaceAvatar = ({ name }) => (
  <div className={styles.fallbackAvatar}>
    <BoringAvatar
      size={10}
      square
      name={name || ''}
      variant="marble"
      colors={[
        'rgba(74,144,226,0.8)',
        'rgba(76,198,215,0.8)',
        'rgba(201,135,229,0.8)',
        'rgba(74,144,226,0.8)',
        'rgba(255,183,74,0.8)',
        'rgba(143,198,96,0.8)',
      ]}
    />
  </div>
);

export default function WorkspaceAvatar({ setAvatarImgFileToUpload, setImageError }) {
  const { activeWorkspace, updateActiveWorkspace } = useWorkspaceContext();

  const getImageFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    setImageError(false);
    const upload = e.target as HTMLInputElement;
    const file = upload.files[0];

    if (!file) {
      return;
    }

    if (file && !acceptedAvatarImageTypes.has(file?.type)) {
      setImageError('Only PNG or JPG files can be uploaded');
      return;
    }

    const url = URL.createObjectURL(file);
    updateActiveWorkspace({ avatarURL: url });
    setAvatarImgFileToUpload(file);
  };

  return (
    <label className={styles.container}>
      {activeWorkspace?.avatarURL ? (
        <div
          className={cn(styles.box, styles.imagePreview)}
          style={
            {
              '--bg-image': `url(${activeWorkspace.avatarURL})`,
            } as CSSProperties
          }
        />
      ) : (
        <div className={styles.box}>
          <FallbackWorkspaceAvatar name={activeWorkspace?.name || ''} />
        </div>
      )}
      <input
        className={styles.fileInput}
        type="file"
        accept=".png,.jpg,.jpeg"
        onChange={getImageFile}
      />
      <CirclePenIcon width={18} height={18} className={styles.penIcon} />
    </label>
  );
}
